import React, {useEffect, useState} from 'react';
import CustomSelect from "../form/CustomSelect";
import {GetReportMethods as getReportMethods} from "../../api/reports/getReportMethods";
import {GetReportMethods as getProgramReportMethods} from "../../api/program-reports/getReportMethods";
import {useTranslation} from "react-i18next";

const ReportMethodSelect = (props) => {

    const { t } = useTranslation();

    const [availableOptions, setAvailableOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const setRoles = async function (){
            try {
                setLoading(true);
                const {data} = await getProgramReportMethods(props.program);
                setAvailableOptions(data?.filter(method => method.enabled));
            } catch (err){
                console.log("Error fetching user roles: " + err);
            } finally {
                setLoading(false);
            }
        }
        if(!props.program) {
            getReportMethods().then(options => setAvailableOptions(options)).catch(err => console.log("Error fetching report methods: " + err));
        } else {
            setRoles();
        }
    }, [props.program]);

    return (
        <CustomSelect
            placeholder={<div>{t(loading ? "Fetching..." : "Select report method")}</div>}
            options={availableOptions}
            onChange={props.onChange}
            value={availableOptions.find(option =>  option.value && props.value && option.value === props.value.toLowerCase())}
            disabled={loading}
        />
    );
};

export default ReportMethodSelect;
